// CommunityLayout - Wraps all community routes, gates by supporter status
// Non-supporters: always see root /community with SupporterOnlyNotice, no tab switching
// Supporters: full access to browse, discord, etc.

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { MainLayout } from '../../components/Layout';
import { useAuth, useAuthRequired } from '../../contexts/AuthContext';
import { CommunityPageHeader, SupporterOnlyNotice } from './components';
import './CommunityShared.css';
import './CommunitySection.css';

export function CommunityLayout() {
  const auth = useAuthRequired({
    payload: {
      action: 'viewCommunity',
      section: 'community',
      timestamp: Date.now(),
    },
    requireAuth: true,
    requireSupporter: false,
  });

  const { user } = useAuth();
  const location = useLocation();
  const path = location.pathname;
  const isAdminPath = path.includes('/community/admin/');

  if (auth.loading || !auth.isAuthorized) return null;

  // Non-supporter trying to access a sub-page: redirect to root /community
  if (!auth.isSupporter && (path.includes('/browse') || path.includes('/discord'))) {
    return <Navigate to="/community" replace />;
  }

  // Admin path requires admin role; non-admins redirect to browse
  if (isAdminPath && user?.role !== 'admin') {
    return <Navigate to="/community/browse" replace />;
  }

  return (
    <MainLayout contentClassName="main-content--community">
      <CommunityPageHeader isSupporter={auth.isSupporter} />
      <div className="community-container">
        {auth.isSupporter ? (
          <Outlet />
        ) : (
          <div className="community-content-centered">
            <SupporterOnlyNotice />
          </div>
        )}
      </div>
    </MainLayout>
  );
}
